import React from 'react';
import { withRouter } from 'react-router-dom';
import RoutePrefixContext from '../../../../new/contexts/RoutePrefixContext';
import Menu from '../../../components/elements/menu/Menu';
import { ROUTE_DATA_MAPS } from '../../../constants/pathnames';
import { ReactComponent as DetailsIcon } from 'new/components/icons/fi-rr-info.svg';

class DataMapDetailActions extends React.Component {
  static contextType = RoutePrefixContext;

  constructor(props) {
    super(props);

    this._handleEditClicked = this._handleEditClicked.bind(this);
    this._handleDeleteClicked = this._handleDeleteClicked.bind(this);
    this._handleOpenDetails = this._handleOpenDetails.bind(this);
  }

  render() {
    const { readOnly, hideMenuDetails } = this.props;
    const menuItems = [];
    if (!hideMenuDetails) {
      menuItems.push({
        label: 'Details',
        icon: <DetailsIcon />,
        onClick: this._handleOpenDetails,
      });
    }

    menuItems.push({
      label: 'Edit',
      icon: (
        <i
          className="fa fa-pencil"
          style={{
            color: '#6D7E8F',
            fontSize: 19,
          }}
          aria-hidden="true"
        />
      ),
      onClick: this._handleEditClicked,
    });
    // {
    //   type: 'dialog',
    //   label: 'Delete',
    //   icon: (
    //     <i
    //       className="fa fa-trash"
    //       style={{
    //         color: '#6D7E8F',
    //         fontSize: 19
    //       }}
    //       aria-hidden="true"
    //     />
    //   ),
    //   dialogMessage: `Please confirm you want to delete the lookup ${
    //     data.name
    //   } (ID: ${data.id})`,
    //   discardLabel: 'Cancel',
    //   confirmLabel: 'Delete',
    //   onClick: this._handleDeleteClicked
    // }

    if (this.props.additionalMenuItems) {
      this.props.additionalMenuItems.forEach((item) => {
        if (item.position === 'bottom') {
          menuItems.push(item);
        } else {
          menuItems.unshift(item);
        }
      });
    }

    return <div className="detail-actions">{!readOnly && <Menu items={menuItems} />}</div>;
  }

  _handleEditClicked() {
    this.props.history.push(`${this.context}${ROUTE_DATA_MAPS}/${this.props.data.id}/edit`);
  }

  _handleDeleteClicked(event) {
    this.props.deleteDataMap(this.props.data.id);
  }

  _handleOpenDetails(e) {
    if (e && typeof e.stopPropagation === 'function') {
      e.stopPropagation();
    }
    const { data, onOpenDetailsMenu, openDetailDrawerInPortal, openDetailsModal } = this.props;
    if (typeof onOpenDetailsMenu === 'function') {
      onOpenDetailsMenu(data);
      return;
    }
    if (typeof openDetailsModal === 'function') {
      openDetailsModal(data);
      return;
    }
    if (typeof openDetailDrawerInPortal === 'function') {
      openDetailDrawerInPortal(data, {});
    }
  }
}

DataMapDetailActions.defaultProps = {
  hideMenuDetails: false,
};

export default withRouter(DataMapDetailActions);
